import React from 'react'
import { SubNavLink } from 'src/Components/shared/Navigation'

const HomeLink = ({ to, active, onClick, children }) => (
  <SubNavLink active={active} onClick={onClick} to={to}>
    {children}
  </SubNavLink>
)

export default HomeLink
